export const PagePadding = {
  mainSectionLeftPadding: 32,
  smallMainSectionLeftPadding: 15,
};
